module.exports = __webpack_public_path__ + "interior_configuration-d65802e23735a7dba80ef364f7ef7841.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/screens/main/screens/phases/phaseShow/tabs/ifiTemplate/templates/assets/interior_configuration.png
// module id = tdwW
// module chunks = client